<div class="carousel-container">
  @if(message(); as msg) {
    <div [ngClass]="{
      'from': msg.senderType === 1,
      'to': msg.senderType === 2
    }">
      @for (item of msg.carousel; track $index; let cardIdx = $index) {
        <div class="carousel-card" [ngClass]="{
          'to-background': msg.senderType === 2,
          'from-background': msg.senderType === 1
        }">
          <img [src]="item.imageUrl" alt="" />
          <div class="carousel-body">
            <p class="carousel-text">{{ item.body }}</p>
          </div>
          <div class="carousel-button">
            @for (button of item.buttons; track $index) {
              <div class="divider"></div>
              <button type="button" class="carousel-btn" [title]="button.text" (click)="onButtonClick(button, cardIdx)">
                @if($index === 0 && button.icon) {
                  <so-svg-icon-ui [name]="formatIconName(button.icon)" color="--whatsapp-audio" [size]="16"></so-svg-icon-ui>
                } @else {
                  <so-svg-icon-ui name="open_in_new" color="--whatsapp-audio" [size]="16"></so-svg-icon-ui>
                }
                <span>{{ button.text }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
